<template>
  <div id="contenedor-main-obras-solicitudes-configuracion-firmas">
    <tool-bar
      v-on:nuevaFirma="registrarNuevaFirma">
    </tool-bar>
    <v-container
      fluid>
      <v-card
        flat>
        <v-card-text>
          <listado
            :listado="getFirmas">
          </listado>
        </v-card-text>
      </v-card>
    </v-container>
    <v-dialog
    v-model="mostrarVentanaEliminarFirma"
     scrollable
      persistent
      width="600">
      <eliminar-firma
      :firmaEliminar='estaFirma'
      modulo='obrassolicitudes'
      v-on:cerrar='cerrarEliminarFirma'>
      </eliminar-firma>
    </v-dialog>
    <v-dialog
      v-model="mostrarRegistrarNuevaFirma"
      scrollable
      persistent
      width="600">
      <v-card>
        <v-card-title>
          Registrar nueva firma
        </v-card-title>
        <v-card-text
          style="max-height: 300px;">
          <registrar-nueva
            modulo="obrassolicitudes"
            ref="registrarNuevaFirma"
            v-on:cerrar="cerrarRegistrarNuevaFirma">
          </registrar-nueva>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            tipo="formCancelar"
            label="Cancelar"
            @click="mostrarRegistrarNuevaFirma = !mostrarRegistrarNuevaFirma">
          </custom-button>
          <custom-button
            tipo="formAceptar"
            label="Guardar"
            @click="$refs.registrarNuevaFirma.guardar()">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import FIRMAS_POR_MODULO from '@/graphql/querys/administracion/configuracion/firmas/firmasPorModulo.gql';
import ToolBar from './ToolBar.vue';
import CustomButton from '@/components/buttons/Button.vue';
import RegistrarNueva from '@/components/administracion/solicitudesobras/configuracion/firmas/Nueva.vue';
import EliminarFirma from '@/components/administracion/solicitudesobras/configuracion/firmas/Eliminar.vue';
import Listado from './listado/Main.vue';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'MainObrasSolicitudesConfiguracionFirmas',
  components: {
    ToolBar,
    CustomButton,
    RegistrarNueva,
    EliminarFirma,
    Listado,
  },
  data() {
    return {
      mostrarRegistrarNuevaFirma: false,
      mostrarVentanaEliminarFirma: false,
      estaFirma: '',
    };
  },
  mounted() {
    eventBus.$on('eliminar-obras-solicitudes-firma', (firma) => {
      this.mostrarVentanaEliminarFirma = true;
      this.estaFirma = firma;
    });
  },
  methods: {
    cerrarEliminarFirma() {
      this.mostrarVentanaEliminarFirma = false;
    },
    cerrarRegistrarNuevaFirma() {
      this.registrarNuevaFirma();
    },
    registrarNuevaFirma() {
      this.mostrarRegistrarNuevaFirma = !this.mostrarRegistrarNuevaFirma;
    },
  },
  apollo: {
    firmasPorModulo: {
      query: FIRMAS_POR_MODULO,
      variables() {
        return {
          modulo: 'obrassolicitudes',
        };
      },
    },
  },
  computed: {
    getFirmas() {
      if (!this.firmasPorModulo) return [];
      // return this.firmasPorModulo.slice().sort((a, b) => a.orden - b.orden);
      return this.firmasPorModulo;
    },
  },
};
</script>

<style lang="scss">

</style>
